module.exports = __webpack_public_path__ + "img/circle4green.18889029.svg";